export default {
    bindings: {
        title: '@'
    },
    controller: 'availabilityBlockController',
    template: require('../views/availability.block.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/components/availability.block.component.js